// Plasma: drifting blobs melted into one shape, its contours the lines — every line the same width across, flowing out from the blobs like stripes' bands; one still blob at the centre is enclosed stripes' round rings.

export default {
	name: 'plasma',
	label: 'Plasma',
	description: 'Drifting blobs whose contours are equal-width lines through a two-colour band family',

	expose: {
		speed: {
			tip: 'How fast the contours flow out from the blobs; negative flows in',
			step: 0.01,
			// Seconds per ring at ×1: width 25 / base 33.75 (lattice).
			period: 0.74,
			initial: 0.5,
			minimum: -8,
			maximum: 8,
		},
		temperature: {
			tip: 'How fast the blobs move; negative reverses, near 0 they gather still at the centre',
			// Seconds per fastest blob orbit at ×1: BLOB_TURN / (base 0.57 × 3 turns) (displacement).
			period: 18.71,
			initial: 1,
		},
		zoom: {
			minimum: 0.125,
			maximum: 4,
			tip: 'Zooms the whole field',
		},
		blobs: {
			initial: 4,
			tip: 'How many blobs drift and melt together',
		},
		blob_size: {
			initial: 60,
			tip: 'Typical blob radius: bigger blobs differ more and melt together sooner',
		},
		blob_soft: {
			initial: 40,
			tip: 'How far apart blobs start melting into one: 0 meets in sharp creases',
		},
		color: {
			initial: '#ff2fa8',
			tip: 'First palette colour',
		},
		color_b: {
			label: 'Color 2',
			initial: '#1fe0c0',
			tip: 'Last palette colour',
		},
		spread: {
			tip: 'Number of colours from Color to Color 2',
			initial: 4,
		},
		repeat: {
			tip: 'Ramp restarts the palette, Mirror walks back',
			initial: 0,
		},
		wash: {
			tip: 'Scrolls the palette through the rings, colours per second',
			initial: 0,
			period: 1,
		},
		width: {
			initial: 25,
			minimum: 0.25,
			maximum: 50,
			step: 0.05,
			tip: 'Width of each contour line, the same everywhere',
		},
		spacing: {
			initial: 0,
			minimum: 0,
			maximum: 50,
			step: 0.05,
			tip: 'See-through gap between lines',
		},
		ground: {
			tip: 'Behind the lines and in their gaps: its colour and opacity',
			initial: '#00000000',
		},
	},

	// Stretch 0: round blobs; a path to a band subset draws them out into its bands.
	lock: { hill_rows: 1, stretch: 0 },
	range: { pan: [-1000, 1000], enclose: [0, 1], stretch: [0, 1] },
}
